import React from "react";
import firebase from "../../Firebase/firebaseConnection";
// import PremiumNextStock from "../img/premium-logo.png";
import Header from "../../Static/Header";
import Footer from "../../Static/Footer";
import CompanyLogos from '../../components/CompanyLogos';
// import logoNextStock from "../../img/logo.png";
import NextStockTitleMark from "../../components/NextStockTitleMark";
import "./Home.css";

import { useTranslation } from "react-i18next";

import NodeBackend from "../../Resources/NodeBackend";
const backend = new NodeBackend();
const API_ENDPOINT = backend.getPath();

export default function Home({ setPage }) {
  // Firebase + state for Long Term pick

  const { t, i18n } = useTranslation();

  // AI Tip state
  const [aiTip, setAiTip] = React.useState("");
  const [showTip, setShowTip] = React.useState(true);
  const [loadingAiTip, setLoadingAiTip] = React.useState(true);

  function getTodayDateString() {
    return new Date().toLocaleDateString("en-CA"); // sempre YYYY-MM-DD
  }
  async function loadAiTip() {
    setLoadingAiTip(true);

    try {
      const today = getTodayDateString();

      // 1) Recuperar uid
      const uid = localStorage.getItem("userUid");
      if (!uid) {
        console.warn("No uid found in localStorage; skipping AI tip call.");
        setAiTip("Unable to load today's market update.");
        return;
      }

      // 2) Buscar AiTips no Firebase
      const aiTipsRef = firebase
        .database()
        .ref("Users")
        .child(uid)
        .child("AiTips");

      const snapshot = await aiTipsRef.once("value");
      let latestTip = null;

      if (snapshot.exists()) {
        const tipsObj = snapshot.val() || {};

        const tipsArray = Object.values(tipsObj)
          .filter((t) => t && t.message)
          .sort((a, b) => {
            const aCreated = a.createdAt || 0;
            const bCreated = b.createdAt || 0;
            return aCreated - bCreated; // mais antiga → mais recente
          });

        if (tipsArray.length > 0) {
          latestTip = tipsArray[tipsArray.length - 1]; // última = mais recente
        }
      }

      // 3) Se já existe tip de hoje no Firebase, usa ela e NÃO chama backend
      if (latestTip && latestTip.date === today && latestTip.message) {
        setAiTip(latestTip.message);
        return;
      }

      const response = await fetch(
        `${API_ENDPOINT}generate-ai-tip`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ uid }),
        }
      );

      // Limite diário já usado (backend: DAILY_TIP_ALREADY_GENERATED)
      if (response.status === 429) {
        let errData = null;
        try {
          errData = await response.json();
        } catch (_) { }

        console.warn("AI Tip daily limit reached:", errData);

        // Se o backend falou que já gerou hoje, mas a gente já tinha alguma tip,
        // usa a última conhecida como fallback.
        if (latestTip && latestTip.message) {
          setAiTip(latestTip.message);
        } else {
          setAiTip("Today's market update was already generated earlier.");
        }
        return;
      }

      if (!response.ok) {
        console.error("AI Tip HTTP error:", response.status, response.statusText);
        setAiTip("Unable to load today's market update.");
        return;
      }

      const data = await response.json();
      console.log("AI Tip response:", data);

      const tip = data?.tip || data?.reply;
      if (!tip) {
        setAiTip("Unable to load today's market update.");
        return;
      }

      // 5) Exibe a tip retornada pelo backend
      setAiTip(tip);
    } catch (error) {
      console.error("AI Tip error:", error);
      setAiTip("Unable to load today's market update.");
    } finally {
      setLoadingAiTip(false);
    }
  }



  React.useEffect(() => {
    async function init() {
      await loadPortfolioOne();
      await loadShortTermPick();
      await loadAiTip();
    }
    init();
  }, []);


  const [longTermPick, setLongTermPick] = React.useState({
    name: "Loading...",
    ticker: "",
  });

  async function loadPortfolioOne() {
    try {
      const ref = firebase.database().ref("PortfolioOne");
      const snapshot = await ref.once("value");

      if (snapshot.exists()) {
        const data = snapshot.val();

        setLongTermPick({
          name: (data.propertyShortName || "N/A").toUpperCase(),
          ticker: (data.propertySymbol || "-").toUpperCase(),
          symbol: (data.propertySymbol || "").toUpperCase()
        });
      }
    } catch (error) {
      console.error("Error loading PortfolioOne:", error);
    }
  }


  // 🔥 Short Term pick state
  const [shortTermPick, setShortTermPick] = React.useState({
    name: "Loading...",
    ticker: "",
    upside: "",
    symbol: ""
  });

  // 🔥 Fetch both attractive lists and pick the best
  async function loadShortTermPick() {
    try {
      const USref = firebase.database().ref("USattractive");
      const CADref = firebase.database().ref("CADattractive");

      const [USsnap, CADsnap] = await Promise.all([
        USref.orderByChild("propertyPricePercent").once("value"),
        CADref.orderByChild("propertyPricePercent").once("value"),
      ]);

      const USlist = [];
      USsnap.forEach(item => {
        USlist.push({
          name: item.val().propertyShortName,
          ticker: item.val().propertySymbol,
          symbol: item.val().propertySymbol,
          upside: parseFloat(item.val().propertyPricePercent) || 0
        });
      });

      const CADlist = [];
      CADsnap.forEach(item => {
        CADlist.push({
          name: item.val().propertyShortName,
          ticker: item.val().propertySymbol,
          symbol: item.val().propertySymbol,
          upside: parseFloat(item.val().propertyPricePercent) || 0
        });
      });

      // Sort each list descending by upside
      USlist.sort((a, b) => b.upside - a.upside);
      CADlist.sort((a, b) => b.upside - a.upside);

      // Top pick from each
      const topUS = USlist[0];
      const topCAD = CADlist[0];

      // 📈 Choose the one with the highest upside
      const best =
        topUS && topCAD
          ? (topUS.upside > topCAD.upside ? topUS : topCAD)
          : (topUS || topCAD);

      if (best) {
        setShortTermPick({
          name: best.name,
          ticker: best.ticker,
          symbol: best.symbol,
          upside: best.upside.toFixed(1) + "%"
        });
      }
    } catch (error) {
      console.error("Error loading short term pick:", error);
    }
  }

  return (
    <div className="home-root">

      <Header setPage={setPage} />

      <main className="home-main">
        {/* Top brand section */}

        <section className="home-hero">
          <div className="search-title-row">
            <NextStockTitleMark className="top10-logo-next-stock" />

            <h2 className="search-title">
              {t("home.nextStockPicks") || "NEXT STOCK PICKS"}
            </h2>

            <NextStockTitleMark className="top10-logo-next-stock" />
          </div>

          <p className="search-subtitle">
            USA & CANADA
          </p>
          <br></br>
        </section>



        {/* Picks section */}
        <section className="home-picks">

          {/* Long Term Pick */}
          <article className="pick-card pick-long">
            <div className="pick-label">
              {t("home.longTermLabel")}
            </div>

            <div className="pick-header">
              <div className="pick-logo">
                <CompanyLogos symbol={longTermPick.symbol} />
              </div>

              <div className="pick-title-wrap">
                <h2 className="pick-company">{longTermPick.name}</h2>
                <p className="pick-ticker">{longTermPick.ticker}</p>
              </div>
            </div>

            <p className="pick-description">
              {t("home.longTermDescription", { name: longTermPick.name })}{" "}
              {t("home.longTermMore")}{" "}
              <span className="pick-link" onClick={() => setPage("Portfolio")}>
                {t("home.seePortfolios")}
              </span>.
            </p>
          </article>

          {/* Short Term Pick */}
          <article className="pick-card pick-short">
            <div className="pick-label">
              {t("home.shortTermLabel")}
            </div>

            <div className="pick-header">
              <div className="pick-logo">
                <CompanyLogos symbol={shortTermPick.symbol} />
              </div>

              <div className="pick-title-wrap">
                <h2 className="pick-company">{shortTermPick.name}</h2>
                <p className="pick-ticker">{shortTermPick.ticker}</p>
              </div>
            </div>

            <p className="pick-description">
              {t("home.shortTermDescription", {
                name: shortTermPick.name,
                upside: shortTermPick.upside
              })}{" "}
              {t("home.shortTermMore")}{" "}
              <span className="pick-link" onClick={() => setPage("Top10")}>
                {t("home.seeTop10")}
              </span>.
            </p>
          </article>

        </section>

        {/* 🔥 AI TIP BUTTON + MODAL */}
        <div className="ai-tip-wrapper">
          {showTip ? (
            <div className="ai-tip-modal">
              <button className="ai-tip-close" onClick={() => setShowTip(false)}>×</button>

              <h4 className="ai-tip-title">
                <strong style={{ fontSize: "20px", marginTop: "-2px" }}>💡✨ </strong>
                {t("home.aiTipTitle")}
              </h4>

              {/* AI Tip with line breaks */}
              <div className="ai-tip-text">
                {loadingAiTip ? (
                  <span>{t("home.aiTipLoading")}</span>
                ) : (
                  <ul className="ai-tip-list">
                    {aiTip
                      .split("\n")
                      .map(line => line.trim())
                      .filter(line => line.length > 0)
                      .map((line, idx) => (
                        <li
                          key={idx}
                          style={{ fontSize: "13px", paddingRight: "50px", marginBlock: "10px" }}
                        >
                          {line}
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            </div>
          ) : (
            <button className="ai-tip-icon" onClick={() => setShowTip(true)}>
              <strong style={{ fontSize: "16px", marginTop: "-3px" }}>💡</strong>
              {t("home.aiTipTitle")}
            </button>
          )}
        </div>

        <section className="home-explore" aria-label={t("home.exploreTitle")}>
          <div className="home-explore-heading">
            <span className="home-explore-eyebrow">NEXT STOCK</span>
            <h2>{t("home.exploreTitle")}</h2>
            <p>{t("home.exploreDescription")}</p>
          </div>
          <div className="home-explore-grid">
            {[
              { page: "Searchp", title: t("home.exploreSearchTitle"), description: t("home.exploreSearchDescription"), icon: "search", number: "01" },
              { page: "Top10", title: t("home.exploreTopTitle"), description: t("home.exploreTopDescription"), icon: "chart", number: "02" },
              { page: "Portfolio", title: t("home.explorePortfolioTitle"), description: t("home.explorePortfolioDescription"), icon: "portfolio", number: "03" },
            ].map((item) => (
              <button type="button" className={`home-explore-card home-explore-${item.icon}`} key={item.page} onClick={() => setPage(item.page)}>
                <span className="home-explore-card-top">
                  <span className="home-explore-icon" aria-hidden="true">
                    {item.icon === "search" ? (
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><circle cx="10.8" cy="10.8" r="6.8"/><path d="m16 16 5 5"/></svg>
                    ) : item.icon === "chart" ? (
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 19h18M5 15l5-5 4 3 6-8"/><path d="M16 5h4v4"/></svg>
                    ) : (
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="15" rx="3"/><path d="M3 10h18M8 5V3m8 2V3M7 15h4m3 0h3"/></svg>
                    )}
                  </span>
                  <span className="home-explore-number">{item.number}</span>
                </span>
                <span className="home-explore-card-title">{item.title}</span>
                <span className="home-explore-card-description">{item.description}</span>
                <span className="home-explore-card-link">{t("home.exploreAction")} <span aria-hidden="true">→</span></span>
              </button>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );

}
